import { Auth } from 'aws-amplify';

export const APP_TOKEN = 'token';

const clearToken = () => {
  localStorage.removeItem(APP_TOKEN);
};

const setToken = (token: string) => {
  localStorage.setItem(APP_TOKEN, token);
};

const hasToken = () => {
  const token = localStorage.getItem(APP_TOKEN);
  return !!token;
};

const getToken = () => {
  return new Promise((resolve, reject) => {
    Auth.currentSession()
      .then((session: any) => {
        const token = localStorage.getItem(APP_TOKEN);
        if (token) {
          resolve(token);
        } else {
          resolve(session.idToken.jwtToken);
        }
      })
      .catch(() => {
        reject();
      });
  });
};

const refreshToken = async () => {
  try {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(currentSession.getRefreshToken(), (err: any, session: { idToken: any }) => {
      const { idToken } = session;
      return Promise.resolve(idToken);
    });
  } catch (e) {
    return Promise.reject();
  }
};
export default {
  setToken,
  getToken,
  hasToken,
  clearToken,
  refreshToken,
};
